<template>
  <svg
    version="1.1"
    id="github"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 128 128"
    style="enable-background:new 0 0 128 128;"
    xml:space="preserve"
  >
    <rect x="10.2" y="23.9" class="st0" width="107.8" height="80.5" />
    <path
      class="st1"
      d="M113.6,14.5h-99C7.8,14.5,2.2,20,2.2,26.9l-0.1,74.3c0,6.8,5.6,12.4,12.4,12.4h99.1c6.8,0,12.4-5.6,12.4-12.4
	V26.9C126,20,120.4,14.5,113.6,14.5z M113.6,101.1h-99V39.2l49.5,31l49.5-31V101.1z M64.1,57.8l-49.5-31h99.1L64.1,57.8z"
    />
  </svg>
</template>

<script>
  export default {
    render() {
      return null
    }
  }
</script>

<style lang="scss" scoped>
  .st1 {
    fill: #d44638;
    transition: 0.25s ease-out;
  }
  .st0 {
    fill: #ffffff;
  }
  svg {
    vertical-align: bottom;
    height: 2rem;
    width: 2rem;
  }
  svg:hover .st1 {
    fill: scale-color($color: #d44638, $lightness: 12%);
  }
</style>
